import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const heroBannerUrl = process.env.PUBLIC_URL + "/Images/HeroBanner.jpg";
  const openingParagraph = `The Delina Research Group is led by Dr. Laurence L. Delina, assistant professor of environment and sustainability. His research interests are on sustainable development with focus on rapid mitigation of climate change and accelerating sustainable and just energy transitions. His research received funding from the Hong Kong Research Grants Council, the United States Institute of Peace, the Sumitomo Foundation, and the Robert H.N. Ho Family Foundation. Laurence is an associate editor of Energy Research & Social Science, an affiliate of HKUST’s Institute for Emerging Market Studies, Energy Institute, and the Fok Ying Tung Research Institute. He has written for the Philippine Daily Inquirer, Bangkok Post, Jakarta Post and The Conversation, and appeared in Al Jazeera, Fortune, and ABS-CBN News. Laurence was a Rachel Carson Fellow, a Balik Scientist, and a Visiting Fellow at Harvard Kennedy School. He received his PhD from the University of New South Wales Sydney.  `;
  const navigate = useNavigate();
  return (
    <>
      <Box style={{ height: "70vh", width: "100%" }}>
        <Box
          style={{
            backgroundImage: `url(${heroBannerUrl})`,
            backgroundSize: "cover",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          <Box
            style={{
              width: "50%",
              background:
                "linear-gradient(270deg, #FFFFFF 5.37%, rgba(255, 255, 255, 0.8) 62.44%, rgba(255, 255, 255, 0) 92.37%)",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography fontWeight={800} fontSize="32px">
              Delina Research Group
            </Typography>
            <Box
              style={{
                background: "rgba(255,255,255,0.5)",
                padding: "16px",
                boxSizing: "border-box",
                borderRadius: "12px",
              }}
            >
              <Typography
                sx={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 6,
                }}
                marginRight="16px"
                textAlign="justify"
              >
                {openingParagraph}
              </Typography>
            </Box>
            <Button
              onClick={() => navigate("/about")}
              style={{
                textTransform: "none",
                cursor: "pointer",
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "16px",
              }}
            >
              <Typography color="black">Read More...</Typography>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeroSection;
